import {useEffect, useState} from 'react';

import Rive from '@rive-app/react-canvas';

import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './chatbot-report-loading-state.module.css';

const LOADING_MESSAGE_ROTATION_INTERVAL = 3000;
const loadingMessages = [
    'Turning chat activity into actionable insights',
    'Finding the questions visitors ask most',
    'Spotlighting pages and nudges that start conversations',
];

export function ChatbotReportLoadingState() {
    const [messageIndex, setMessageIndex] = useState(0);

    useEffect(() => {
        const intervalId = window.setInterval(() => {
            setMessageIndex((currentIndex) => (currentIndex + 1) % loadingMessages.length);
        }, LOADING_MESSAGE_ROTATION_INTERVAL);

        return () => window.clearInterval(intervalId);
    }, []);

    return (
        <div className='flex justify-center align-center flex-dir-col py-64 gap-16'>
            <div className={styles['animation-container']}>
                <Rive src='/include/rive/reports/chatbot-report-generating.riv' />
            </div>
            <Stack spacing={8} alignItems='center'>
                <Body color='dark' size='large' isBold={true}>
                    Loading chatbot report
                </Body>
                <Body textAlign='center'>{loadingMessages[messageIndex]}</Body>
            </Stack>
        </div>
    );
}
